import { Card, Input } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { Guarantors } from '../Guarantors/Guarantors';
import { useSignupData } from '../hooks/useSignupData';
import { PersonalDetails } from '../PersonalDetails/PersonalDetails';
import { TSignupFormData } from '../SignupForm/SignupForm';

import signupFormStyles from '../SignupForm/SignupForm.module.css';
import styles from './ClientDetails.module.css';

export const ClientDetails = () => {
  const { stateData } = useSignupData();

  const {
    register,
    formState: { errors },
  } = useFormContext<TSignupFormData>();

  return (
    <Card className={signupFormStyles.formSection}>
      <h2>Applicant details</h2>
      {/* Introducers coming through the API might have missed this information off,
      if they come through step 0 they won't see this */}
      {(!stateData.companyNumber || !stateData.companyNumber) && (
        <div className={styles.nameContainer}>
          <Input
            {...register(`applicant.firstName`)}
            type="text"
            label="First name"
            wrapperClassName={styles.nameField}
            error={errors?.applicant?.firstName?.message}
          />
          <Input
            {...register(`applicant.lastName`)}
            type="text"
            label="Last name"
            wrapperClassName={styles.nameField}
            error={errors?.applicant?.lastName?.message}
          />
        </div>
      )}
      {/* eslint-disable-next-line jsx-a11y/aria-role */}
      <PersonalDetails role="applicant" />
      <Guarantors />
    </Card>
  );
};
